import { useState } from "react";
import LandingNav from "@/components/landing/LandingNav";
import DualHero from "@/components/landing/DualHero";
import AudienceToggle from "@/components/landing/AudienceToggle";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import HowItWorks from "@/components/landing/HowItWorks";
import PositioningStatement from "@/components/landing/PositioningStatement";
import BeforeAfterCompliance from "@/components/landing/BeforeAfterCompliance";
import PractitionerProblem from "@/components/landing/PractitionerProblem";
import PractitionerSolution from "@/components/landing/PractitionerSolution";
import PractitionerHowItWorks from "@/components/landing/PractitionerHowItWorks";
import PractitionerPositioning from "@/components/landing/PractitionerPositioning";
import Footer from "@/components/landing/Footer";
import SectorGuides from "@/components/landing/SectorGuides";
import usePageMeta from "@/hooks/usePageMeta";

const Index = () => {
  const [audience, setAudience] = useState<"brand" | "practitioner">("brand");

  usePageMeta({
    title: "CompliGUARD | AI Compliance Infrastructure for Australian Health Marketing — TGA · AHPRA · FSANZ · ACCC",
    description:
      "AI-powered compliance for Australian health brands and practitioners. Review content against AHPRA, TGA, FSANZ and ACCC guidelines.",
    canonical: "https://compliguard.com.au/",
  });

  return (
    <div className="min-h-screen bg-background">
      <LandingNav />
      <main>
        <DualHero />
        <AudienceToggle audience={audience} onChange={setAudience} />
        {audience === "brand" ? (
          <>
            <Problem />
            <Solution />
            <BeforeAfterCompliance audience="brand" />
            <HowItWorks />
            <PositioningStatement />
          </>
        ) : (
          <>
            <PractitionerProblem />
            <PractitionerSolution />
            <BeforeAfterCompliance audience="practitioner" />
            <PractitionerHowItWorks />
            <PractitionerPositioning />
          </>
        )}
        <SectorGuides />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
